import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { useParams } from "react-router-dom";
import { useUser } from './Context/UserContext';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import "../styles/CreateInvoice.css";
import "../styles/forms-redesign.css";
import profileImg from '../assets/logo.png';
import DashboardLayout from "../components/DashboardLayout";
const CreateInvoice = () => {
    const invoiceFileRef = useRef(null);
    const poFileRef = useRef(null);
    const timesheetRef = useRef(null);
    const agreementCopyRef = useRef(null);   //
    const [formData, setFormData] = useState({
        invoiceType: "",
        supplierType: "",
        poType: "",           // 
        invoiceDate: "",
        invoiceNo: "",
        poNo: "",
        poDate: "",
        deliveryChallanNo: "",
        invoiceCopy: null,
        poCopy: null,
        timesheet: null,
        agreementCopy: null,  // 
        fileName: "",
        fileNameAgreement: "",
        fileNameTimeSheet: "",
        invoiceFilePath: "",    
        poFilePath: "",         
        timesheetFilePath: "",   
        agreementRef: "",     // 
        agreementAmount: "",  // 
        agreementType: "",
        
    });
    const { id } = useParams();
    const { user, logoutUser } = useUser();
    const userId = user?.id || sessionStorage.getItem("userId");
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [successMessage, setSuccessMessage] = useState('');
    const [error, setError] = useState('');
    const [vendorId, setVendorId] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [showCard, setShowCard] = useState(false);
    const [expandedMenus, setExpandedMenus] = useState({});
    const [rowErrors, setRowErrors] = useState([]);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false); // prevents double submit
    const [isUpdating, setIsUpdating] = useState(false); // prevents double update
    const [agreementList, setAgreementList] = useState([]);//
    const [fileModalUrl, setFileModalUrl] = useState(null);//
    const [fileModalType, setFileModalType] = useState(null); // NEW
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode"); // "view" | "modify" | null
    const isViewMode = mode === "view";
    const isModifyMode = mode === "modify";
    const isCreateMode = !id;
    const disabled = isViewMode;
    const showActionsCol = isCreateMode || isModifyMode ;
    const [rows, setRows] = useState([
        { SlNo: 1, Description: "", Qty: "", RcvQty: "", invoiceValue: 0, cgst: 0, sgst: 0, igst: 0, totalValue: "0.00", remark: "" }
    ]);
    // ─── SIDEBAR ─────────────────────────────────────────────────────────────────
    const toggleExpand = (menuId) =>
        setExpandedMenus(prev => ({ ...prev, [menuId]: !prev[menuId] }));
    const handleLogout = () => {
        logoutUser();
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
    };
    // ─── FETCH INVOICE + GRN ITEMS ────────────────────────────────────────────────
    useEffect(() => {
        if (!id) return;
        axios.get(`/api/invoices/details/${id}`)
            .then(res => {
                const d = res.data;
                console.log("Invoice API response:", d);
                setFormData(prev => ({
                    ...prev,
                    invoiceType: d.invoiceType || "",
                    supplierType: String(d.invoiceSupplierType || ""),
                    poType: d.poType || (d.pono ? "PO" : (d.agreementId ? "Agreement" : "")),
                    agreementRef: d.agreementId ? String(d.agreementId) : "",
                    invoiceDate: d.invoiceDate ? d.invoiceDate.split("T")[0] : "",
                    invoiceNo: d.invoiceNo || "",
                    poNo: d.pono || "",
                    poDate: d.po_Date ? d.po_Date.split("T")[0] : "",
                    deliveryChallanNo: d.deliveryChallanNumber || "",
                    fileName: d.fileName || "",
                    fileNameAgreement: d.fileNameAgreement || "",
                    fileNameTimeSheet: d.fileNameTimeSheet || "",
                    invoiceFilePath: d.invoiceFilePath || "",       
                    poFilePath: d.poFilePath || "",                
                    timesheetFilePath: d.timesheetFilePath || "",
                    invoiceCopy: null,
                    poCopy: null,
                    timesheet: null,
                }));
                if (d.agreementId) {
                    setAgreementList(prev =>
                        prev.some(a => String(a.agreementId) === String(d.agreementId))
                            ? prev
                            : [...prev, {
                                agreementId: d.agreementId,
                                agreementDate: d.agreementDate || "N/A",
                                agreementAmount: d.agreementAmount || "",
                                agreementType: d.agreementType || "",
                                fileName: d.agreementFileName || "",
                                filePath: d.agreementFilePath || "",
                            }]
                    );
                }
            })
            .catch(err => console.error("Error fetching invoice:", err));
        axios.get(`/api/invoices/grnitems/${id}`)
            .then(res => {
                const items = res.data;
                console.log("GRN items response:", items);
                if (Array.isArray(items) && items.length > 0) {
                    setRows(items.map((item, i) => ({
                        SlNo: i + 1,
                        Description: item.description || item.Description || "",
                        Qty: item.qty || item.Qty || "",
                        RcvQty: item.rcvQty || item.RcvQty || "",
                        invoiceValue: item.invoiceValue || item.InvoiceValue || 0,
                        cgst: item.cgst || item.CGST || 0,
                        sgst: item.sgst || item.SGST || 0,
                        igst: item.igst || item.IGST || 0,
                        totalValue: String(item.totalValue || item.TotalValue || "0.00"),
                        remark: item.remark || item.Remark || "",
                    })));
                }
            })
            .catch(err => console.error("Error fetching GRN items:", err));
    }, [id]);
    //─── QTY CONSTANT ───────────────────────────────────────────────────────
    useEffect(() => {
        if (formData.supplierType === "2") {
            setRows(prev => prev.map(row => ({
                ...row,
                Qty: row.Qty || "1",
                RcvQty: row.RcvQty || "1",
            })));
        }
    }, [formData.supplierType]);

    // ─── FETCH VENDOR AGREEMENTS ─────────────────────────────────────────────────
    useEffect(() => {
        const uid = user?.id || user?.ID || sessionStorage.getItem("userId");
        console.log("Agreement fetch — poType:", formData.poType, "uid:", uid);
        if (formData.supplierType !== "2" && formData.supplierType !== "3") return;
        if (!uid) {
            console.warn("No userId found!");
            return;
        }
        axios.get(`/api/vendoragreement/byuser/${uid}`)
            .then(res => {
                console.log("Agreements returned:", res.data);
                setAgreementList(res.data || []);
            })
            .catch(err => console.error("Agreement fetch error:", err));
    }, [formData.poType, user]);

    // ─── FETCH USER DETAILS ───────────────────────────────────────────────────────
    useEffect(() => {
        const fetchUserDetails = async () => {
            if (!userId) return;
            try {
                const { data: userData } = await axios.get(
                    `/api/vendors/userdetails/${userId}`
                );
                setFormData(prev => ({
                    ...prev,
                    vendorName: userData?.nameOfCompany || "",
                    vendorEmail: userData?.emailId || "",
                    telephone: userData?.contactNumber || "",
                }));
            } catch (err) {
                console.error("Error fetching user details:", err);
            }
        };
        fetchUserDetails();
    }, [user]);
    // ─── FIELD HANDLERS ───────────────────────────────────────────────────────────
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Agreement reference selected → auto-fill amount & date
        if (name === "agreementRef") {
            const selected = agreementList.find(a => String(a.agreementId) === String(value));
            setFormData(prev => ({
                ...prev,
                agreementRef: value,
                agreementAmount: selected?.agreementAmount || "",
                agreementDate: selected?.agreementDate || "",
                agreementType: selected?.agreementType || "",
            }));
            validateField(name, value);
            return;
        }

        setFormData(prev => {
            const updated = { ...prev, [name]: value };

            // Supply of Material (1) → auto-select PO
            if (name === "supplierType") {
                if (value === "1") {
                    updated.poType = "PO";  // auto-select PO for Material
                } else {
                    updated.poType = "";    // reset for others
                }
                updated.agreementRef = "";
                updated.agreementAmount = "";
            }

            // Agreement selected → auto-fill poNo since the field is now hidden
            if (name === "poType") {
                if (value === "Agreement") {
                    updated.poNo = "Agreement";
                    updated.deliveryChallanNo = ""; // clear since field is now hidden
                } else if (prev.poNo === "Agreement") {
                    updated.poNo = ""; // clear the auto value if switching back to PO
                }
            }

            return updated;
        });

        validateField(name, value);
    };
    const poTypeToInt = (val) => (val === "PO" ? 1 : val === "Agreement" ? 2 : val === "Approval" ? 3 : null);
    const intToPoType = (val) => (val === 1 ? "PO" : val === 2 ? "Agreement" : val === 3 ? "Approval" : "");

    const handleFileChange = (e, fieldName) => {
        if (!e?.target?.files) return;
        const file = e.target.files[0];
        setFormData(prev => ({ ...prev, [fieldName]: file || null }));
        setErrors(prev => {
            const newErrors = { ...prev };
            if (file) {
                delete newErrors[fieldName]; // remove error if file selected
            } else {
                newErrors[fieldName] = "Please select a file"; // set error if no file
            }
            return newErrors;
        });
    };
    const handleDecimalInput = (e) => {
        if (!/^[0-9]*\.?[0-9]*$/.test(e.target.value)) e.preventDefault();
    };
    const handleIntegerInput = (e) => {
        if (!/^[0-9]*$/.test(e.target.value)) e.preventDefault();
    };
    // ─── ROW HANDLERS ─────────────────────────────────────────────────────────────
    const handleRowChange = (arg1, arg2, arg3) => {
        let index, name, value;
        if (arg1?.target) {
            index = arg2;
            name = arg1.target.name || arg1.target.id;
            value = arg1.target.value;
        } else {
            index = arg1; name = arg2; value = arg3;
        }
        if (index == null || name == null) return;
        setRows(prevRows => {
            const updated = prevRows.map(r => ({ ...r }));
            if (["invoiceValue", "cgst", "sgst", "igst"].includes(name)) {
                updated[index][name] = parseFloat(String(value).replace(/,/g, "")) || 0;
            } else {
                updated[index][name] = value;
            }
            const iv = parseFloat(updated[index].invoiceValue) || 0;
            const cg = parseFloat(updated[index].cgst) || 0;
            const sg = parseFloat(updated[index].sgst) || 0;
            const ig = parseFloat(updated[index].igst) || 0;
            updated[index].totalValue = (iv + iv * (cg + sg + ig) / 100).toFixed(2);
            return updated;
        });
    };
    const addRow = () => {
        const lastRow = rows[rows.length - 1];
        const errs = {};
        if (!lastRow.Description?.trim()) errs.Description = "Description is required";
        if (!lastRow.invoiceValue || Number(lastRow.invoiceValue) === 0) errs.invoiceValue = "Invoice Value is required";
        if (!lastRow.totalValue?.toString().trim()) errs.totalValue = "Total Value is required";
        if (!lastRow.remark?.trim()) errs.remark = "Remarks are required";
        if (Object.keys(errs).length > 0) {
            setRowErrors(prev => { const e = [...prev]; e[rows.length - 1] = errs; return e; });
            return;
        }
        setRowErrors([]);
        setRows(prev => [...prev, {
            SlNo: prev.length + 1, Description: "", Qty: formData.supplierType === "2" ? "1" : "",  // ✅ default 1 for service
            RcvQty: formData.supplierType === "2" ? "1" : "",  // ✅ default 1 for service
            invoiceValue: 0, cgst: 0, sgst: 0, igst: 0, totalValue: "0.00", remark: ""
        }]);
    };
    const removeRow = (index) =>
        setRows(prev => prev.filter((_, i) => i !== index).map((r, i) => ({ ...r, SlNo: i + 1 })));
    // ─── VALIDATION ───────────────────────────────────────────────────────────────
    const validateField = (name, value) => {
        setErrors(prev => {
            const newErrors = { ...prev };
            switch (name) {
                case "poType"://
                    if (!value) newErrors.poType = "Please select PO or Agreement.";
                    else delete newErrors.poType;
                    break;
                case "invoiceType":
                    if (!value) newErrors.invoiceType = "Invoice Type is required.";
                    else delete newErrors.invoiceType;
                    break;
                case "supplierType":
                    if (!value) newErrors.supplierType = "Supplier Type is required.";
                    else delete newErrors.supplierType;
                    break;
                case "invoiceCopy":
                    if (!value) newErrors.invoiceCopy = "Invoice Copy is required.";
                    else delete newErrors.invoiceCopy;
                    break;
                case "invoiceDate":
                    if (!value) newErrors.invoiceDate = "Invoice Date is required.";
                    else delete newErrors.invoiceDate;
                    break;
                case "invoiceNo":
                    if (!value) newErrors.invoiceNo = "Invoice Number is required.";
                    else delete newErrors.invoiceNo;
                    break;
                case "poNo":
                    if (!value) newErrors.poNo = "PO / Agreement Number is required.";
                    else delete newErrors.poNo;
                    break;
                case "poDate":
                    if (!value) newErrors.poDate = "PO / Agreement Date is required.";
                    else delete newErrors.poDate;
                    break;
                case "poCopy":
                    if (!value) newErrors.poCopy = "PO / Agreement Copy is required.";
                    else delete newErrors.poCopy;
                    break;
                case "deliveryChallanNo":
                    if ((formData.supplierType === "1" || formData.supplierType === "3") && formData.poType !== "Agreement" && !value)
                        newErrors.deliveryChallanNo = "Delivery Challan Number is required.";
                    else delete newErrors.deliveryChallanNo;
                    break;
                case "agreementRef":
                    if (!value) newErrors.agreementRef = "Agreement Reference is required.";
                    else delete newErrors.agreementRef;
                    break;
                default:
                    break;
            }
            return newErrors;
        });
    };
    //-------for submit----------------
    const validate = () => {
        const newErrors = {};
        if (!formData.invoiceType) newErrors.invoiceType = "Invoice Type is required.";
        if (!formData.poType) newErrors.poType = "Please select PO or Agreement.";   //
        if (!formData.supplierType) newErrors.supplierType = "Supplier Type is required.";
        if (!formData.invoiceCopy) newErrors.invoiceCopy = "Invoice Copy is required.";
        if (!formData.invoiceDate) newErrors.invoiceDate = "Invoice Date is required.";
        if (!formData.invoiceNo) newErrors.invoiceNo = "Invoice Number is required.";
        if (formData.poType === "PO" && !formData.poNo) newErrors.poNo = "PO Number is required.";
        if (formData.poType === "Agreement" && !formData.agreementRef) {
            newErrors.agreementRef = "Agreement Reference is required.";
        }
        if (formData.poType === "PO" && !formData.poDate) newErrors.poDate = "PO / Agreement Date is required.";
        if (formData.poType === "PO" && !formData.poCopy) newErrors.poCopy = "PO / Agreement Copy is required.";
        if ((formData.supplierType === "1" || formData.supplierType === "3") && formData.poType !== "Agreement" && !formData.deliveryChallanNo) {
            newErrors.deliveryChallanNo = "Delivery Challan Number is required.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const checkInvoiceExists = async (invoiceNo, excludeInvoiceId = null) => {
        try {
            const params = new URLSearchParams();
            params.append("userId", userId);
            if (excludeInvoiceId) params.append("excludeId", excludeInvoiceId);
            await axios.get(
                `/api/invoices/check-invoice-no/${invoiceNo}?${params.toString()}`
            );
            return false;
        } catch (err) {
            if (err.response?.status === 400) return true;
            throw err;
        }
    };
    // ─── SHA-256 FILE HASH (detects identical content regardless of filename) ─────
    const readAsBuffer = (file) =>
        new Promise((res, rej) => {
            const reader = new FileReader();
            reader.onload = () => res(reader.result);
            reader.onerror = () => rej(new Error("File read failed"));
            reader.readAsArrayBuffer(file);
        });
    const hashFile = async (file) => {
        if (!window.crypto?.subtle) {
            console.warn("crypto.subtle not available (requires HTTPS) — skipping file hash check.");
            return null;
        }
        const buffer = await readAsBuffer(file);
        const digest = await crypto.subtle.digest("SHA-256", buffer);
        return Array.from(new Uint8Array(digest))
            .map(b => b.toString(16).padStart(2, "0")).join("");
    };
    const checkFilesUnique = async (invoiceCopy, poCopy, timesheet) => {
        const filePairs = [
            { file: invoiceCopy, label: "Invoice Copy" },
            { file: poCopy, label: "PO / Agreement Copy" },
            { file: timesheet, label: "Timesheet" },
        ].filter(f => f.file);
        if (filePairs.length < 2) return true; // nothing to compare
        const hashed = await Promise.all(
            filePairs.map(async f => ({ ...f, hash: await hashFile(f.file) }))
        );
        if (hashed.some(h => h.hash === null)) return true;
        for (let i = 0; i < hashed.length; i++) {
            for (let j = i + 1; j < hashed.length; j++) {
                if (hashed[i].hash === hashed[j].hash) {
                    alert(
                        `"${hashed[i].label}" and "${hashed[j].label}" are the same file.\n` +
                        `Please upload different files.`
                    );
                    return false;
                }
            }
        }
        return true;
    };
    // ─── SUBMIT (CREATE) ──────────────────────────────────────────────────────────
    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Guard: prevent double submission
        if (isSubmitting) return;
        console.log("validate result:", validate());
        console.log("poType:", formData.poType);
        console.log("agreementAmount:", formData.agreementAmount);
        console.log("errors after validate:", errors);
        if (!validate()) return;
        if (!userId) return alert("User not identified. Please log in.");
        const hasValidRow = rows.some(r =>
            r.Description?.trim() && r.invoiceValue &&
            r.totalValue?.toString().trim() && r.remark?.trim()
        );
        if (!hasValidRow) return alert("At least one table row must have all fields filled.");
        

        // Check invoice number uniqueness
        const exists = await checkInvoiceExists(formData.invoiceNo);
        if (exists) return alert(`Invoice number "${formData.invoiceNo}" already exists. Please check the invoice number.`);
        // Check uploaded files are unique (SHA-256)
        const filesUnique = await checkFilesUnique(
            formData.invoiceCopy,
            formData.poCopy,
            formData.timesheet
        );
        if (!filesUnique) return; // alert already shown inside checkFilesUnique
        setIsSubmitting(true);
        try {
            // ── STEP 1: Create invoice record ──────────────────────────────────
            const safeAppend = (form, key, value) => form.append(key, value || "");
            const createForm = new FormData();
            safeAppend(createForm, "invoiceType", formData.invoiceType);
            safeAppend(createForm, "InvoiceDate", formData.invoiceDate);
            safeAppend(createForm, "InvoiceNo", formData.invoiceNo);
            safeAppend(createForm, "pono", formData.poNo);
            safeAppend(createForm, "PO_Date", formData.poDate);
            safeAppend(createForm, "DeliveryChallanNumber", formData.deliveryChallanNo);
            safeAppend(createForm, "Dept_ID", "1");
            safeAppend(createForm, "USERID", userId);
            safeAppend(createForm, "supplierType", formData.supplierType);
            safeAppend(createForm, "POType", poTypeToInt(formData.poType));
            safeAppend(createForm, "AgreementId", formData.poType === "Agreement" ? formData.agreementRef : "");
            const createResponse = await axios.post(
                "/api/invoices/vendorinvoicedetails",
                createForm,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            const invoiceId = createResponse.data.invoiceId || createResponse.data.id;
            if (!invoiceId) return alert("Invoice created but ID not returned from backend.");
            // ── STEP 2: Save GRN rows ──────────────────────────────────────────
            const isService = formData.supplierType === "2";
            const grnItems = rows.map(item => ({
                Description: item.Description,
                InvoiceValue: parseFloat(item.invoiceValue) || 0,
                CGST: parseFloat(item.cgst) || 0,
                SGST: parseFloat(item.sgst) || 0,
                IGST: parseFloat(item.igst) || 0,
                TotalValue: parseFloat(item.totalValue) || 0,
                remark: item.remark || "",
                Qty: isService ? 1 : (parseFloat(item.Qty) || 0),
                RcvQty: isService ? 1 : (parseFloat(item.RcvQty) || 0),
            }));
            await axios.post(
                `/api/invoices/grnitems/add?grnId=${invoiceId}`,
                grnItems,
                { headers: { "Content-Type": "application/json" } }
            );
            // ── STEP 3: Upload files to folders ───────────────────────────────
            const reviewForm = new FormData();
            reviewForm.append("Id", Number(invoiceId));
            reviewForm.append("Dept_ID", "1");
            // Read ApprovalStatus — never fall back to 1, derive from supplierType directly
            const approvalStatus = createResponse.data.ApprovalStatus
                || createResponse.data.approvalStatus
                || (formData.supplierType === "2" ? 3 : 2);
            reviewForm.append("ApprovalStatus", approvalStatus);
            if (formData.invoiceCopy) reviewForm.append("InvoiceFile", formData.invoiceCopy);
            if (formData.poCopy) reviewForm.append("POFile", formData.poCopy);
            if (formData.timesheet) reviewForm.append("TimesheetFile", formData.timesheet);
            try {
                await axios.post(
                    "/api/invoices/vendorinvoicedetails-review",
                    reviewForm,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
            } catch (reviewErr) {
                // Step 3 failed — delete the invoice record created in Step 1
                try { await axios.delete(`/api/invoices/${invoiceId}`); } catch (_) { }
                const errData = reviewErr.response?.data;
                const errMsg = typeof errData === "string"
                    ? errData
                    : errData?.message || errData?.mainError || "File upload failed.";
                alert(errMsg);
                return;
            }
            // ── SUCCESS ────────────────────────────────────────────────────────
            alert("Invoice submitted successfully!");
            navigate("/ViewAllInvoice");
            //setRows([{ SlNo: 1, Description: "", invoiceValue: 0, cgst: 0, sgst: 0, igst: 0, totalValue: "0.00", remark: "" }]);
            //setFormData({
            //    invoiceType: "", supplierType: "", invoiceDate: "", invoiceNo: "",
            //    poNo: "", poDate: "", deliveryChallanNo: "",
            //    invoiceCopy: null, poCopy: null, timesheet: null,
            //    fileName: "", fileNameAgreement: "", fileNameTimeSheet: "",
            //});
            //if (invoiceFileRef?.current) invoiceFileRef.current.value = "";
            //if (poFileRef?.current) poFileRef.current.value = "";
            //if (timesheetRef?.current) timesheetRef.current.value = "";
            //setErrors({});
            //setSuccessMessage("");
            //setError("");
            //setIsSubmitted(false);
            //setVendorId(null);
        } catch (err) {
            console.error("FULL SUBMIT ERROR:", err.response?.data || err);
            setError(err.response?.data?.message || "There was an error submitting the invoice.");
        } finally {
            setIsSubmitting(false);
        }
    };
    // ─── UPDATE (EDIT in Modify mode) ────────────────────────────────────────────
    const handleUpdate = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isUpdating) return;
        // Check if invoice number already exists ────────────────
        try {
            const invoiceExists = await checkInvoiceExists(formData.invoiceNo, id);            if (invoiceExists) {
                alert(`Invoice number "${formData.invoiceNo}" already exists. Please check your invoice number.`);
                return; // stop update
            }
        } catch (err) {
            console.error("Error checking invoice number:", err);
            alert("Could not verify invoice number . Please try again.");
            return;
        }
        // Check uploaded files are unique if any new files selected
        const hasNewFiles = formData.invoiceCopy || formData.poCopy || formData.timesheet;
        if (hasNewFiles) {
            const filesUnique = await checkFilesUnique(
                formData.invoiceCopy,
                formData.poCopy,
                formData.timesheet
            );
            if (!filesUnique) return;
        }
        setIsUpdating(true);
        try {
            // ── STEP 1: Update invoice header ──────────────────────────────────
            const updateForm = new FormData();
            updateForm.append("invoiceType", formData.invoiceType);
            updateForm.append("InvoiceDate", formData.invoiceDate);
            updateForm.append("InvoiceNo", formData.invoiceNo);
            updateForm.append("pono", formData.poNo);
            updateForm.append("PO_Date", formData.poDate);
            updateForm.append("DeliveryChallanNumber", formData.deliveryChallanNo);
            updateForm.append("supplierType", formData.supplierType);
            updateForm.append("POType", poTypeToInt(formData.poType) ?? "");
            updateForm.append("AgreementId", formData.poType === "Agreement" ? formData.agreementRef : "");
            updateForm.append("USERID", userId);
            const updateResponse = await axios.put(
                `/api/invoices/vendorinvoicedetails/${id}`,
                updateForm,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            // ── STEP 2: Replace GRN rows ───────────────────────────────────────
            const isService = formData.supplierType === "2";
            const grnItems = rows.map(item => ({
                Description: item.Description,
                InvoiceValue: parseFloat(item.invoiceValue) || 0,
                CGST: parseFloat(item.cgst) || 0,
                SGST: parseFloat(item.sgst) || 0,
                IGST: parseFloat(item.igst) || 0,
                TotalValue: parseFloat(item.totalValue) || 0,
                remark: item.remark || "",
                Qty: isService ? 1 : (parseFloat(item.Qty) || 0),
                RcvQty: isService ? 1 : (parseFloat(item.RcvQty) || 0),
            }));
            await axios.put(
                `/api/invoices/grnitems/update?grnId=${id}`,
                grnItems,
                { headers: { "Content-Type": "application/json" } }
            );
            // ── STEP 3: Re-upload files only if new files selected ─────────────
            const approvalStatus = updateResponse.data?.approvalStatus
                || updateResponse.data?.ApprovalStatus
                || (formData.supplierType === "2" ? 3 : 2);
            if (hasNewFiles) {
                const reviewForm = new FormData();
                reviewForm.append("Id", Number(id));
                reviewForm.append("Dept_ID", "1");
                reviewForm.append("ApprovalStatus", updateResponse.data?.approvalStatus || 1);
                if (formData.invoiceCopy) reviewForm.append("InvoiceFile", formData.invoiceCopy);
                if (formData.poCopy) reviewForm.append("POFile", formData.poCopy);
                if (formData.timesheet) reviewForm.append("TimesheetFile", formData.timesheet);
                try {
                    await axios.post(
                        "/api/invoices/vendorinvoicedetails-review",
                        reviewForm,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );
                } catch (reviewErr) {
                    const errData = reviewErr.response?.data;
                    const errMsg = typeof errData === "string"
                        ? errData
                        : errData?.message || errData?.mainError || "File upload failed.";
                    alert(errMsg);
                    return;
                }
            }
            alert("Invoice updated successfully!");
            navigate("/ViewAllInvoice");
        } catch (err) {
            const msg = err.response?.data?.message
                || err.response?.data
                || err.message
                || "Unknown error";
            console.error("Update error:", err.response?.data || err);
            alert("Update failed: " + msg);
        } finally {
            setIsUpdating(false);
        }
    };

    // ─── VIEW AGREEMENT FILE (fetch as blob, avoids CORS/iframe issues) ──────────
    // ─── VIEW AGREEMENT FILE (preview PDFs/images, download everything else) ────
    const viewAgreementFile = async (selected) => {
        try {
            const cleanPath = selected.filePath.startsWith("/") ? selected.filePath : `/${selected.filePath}`;
            const res = await axios.get(
                cleanPath,
                { responseType: "blob" }
            );
            const blobUrl = URL.createObjectURL(res.data);
            const mimeType = res.data.type;
            const isPreviewable = mimeType === "application/pdf" || mimeType.startsWith("image/");

            if (!isPreviewable) {
                const a = document.createElement("a");
                a.href = blobUrl;
                a.download = selected.fileName || "agreement-file";
                a.click();
                URL.revokeObjectURL(blobUrl);
                return;
            }

            setFileModalUrl(blobUrl);
            setFileModalType(mimeType);
        } catch (err) {
            console.error("Error loading agreement file:", err);
            alert("Could not load the agreement file.");
        }
    };
    const viewUploadedFile = async (filePath, fileName) => {
        if (!filePath) return;
        try {
            const cleanPath = filePath.startsWith("/") ? filePath : `/${filePath}`;
            const res = await axios.get(cleanPath, { responseType: "blob" });
            const blobUrl = URL.createObjectURL(res.data);
            const mimeType = res.data.type;
            const isPreviewable = mimeType === "application/pdf" || mimeType.startsWith("image/");
            if (!isPreviewable) {
                const a = document.createElement("a");
                a.href = blobUrl;
                a.download = fileName || "file";
                a.click();
                URL.revokeObjectURL(blobUrl);
                return;
            }
            setFileModalUrl(blobUrl);
            setFileModalType(mimeType);
        } catch (err) {
            console.error("Error loading file:", err);
            alert("Could not load the file.");
        }
    };
    const buildMenuTree = (menuItems) => {
        if (!Array.isArray(menuItems)) return [];
        const menuMap = {};
        const roots = [];
        menuItems.forEach(item => { if (item.Id != null) menuMap[item.Id] = { ...item, children: [] }; });
        menuItems.forEach(item => {
            if (item.Id == null) return;
            const parentId = item.Parentmenuid;
            if (parentId && menuMap[parentId]) menuMap[parentId].children.push(menuMap[item.Id]);
            else roots.push(menuMap[item.Id]);
        });
        return roots;
    };
    //const menuIcons = {
    //    vendors: '🏪',
    //    'create invoice': '📄',
    //    'view all invoice': '📋',
    //    dashboard: '⊞',
    //    default: '◈',
    //};
    //const getIcon = (name = '') => menuIcons[name.toLowerCase()] ?? menuIcons.default;
    //const menuTree = buildMenuTree(user?.menus || []);
    // ─── PAGE TITLE ───────────────────────────────────────────────────────────────
    const pageTitle = isViewMode ? "View Invoice Details"
        : isModifyMode ? "Modify Invoice Details"
            : "Fill Invoice Details";
    return (
        <DashboardLayout>
            <div className="vendors-container">
                {/* Sidebar & Main Layout */}
                <div className="main-layout">
                    {/* Sidebar */}
                    {/*<div className={`vendor-sidebar-v2 ${sidebarOpen ? 'open' : 'closed'}`}>*/}
                    {/*    <ul>*/}
                    {/*        {menuTree.length === 0 ? (*/}
                    {/*            <li style={{ padding: '8px 20px', color: '#52525b', fontSize: '12px' }}>*/}
                    {/*                No menu items*/}
                    {/*            </li>*/}
                    {/*        ) : (*/}
                    {/*            menuTree.map(menu => {*/}
                    {/*                const parentActive =*/}
                    {/*                    location.pathname.toLowerCase() === menu.MenuLink?.toLowerCase() ||*/}
                    {/*                    menu.children?.some(sub =>*/}
                    {/*                        location.pathname.toLowerCase() === sub.MenuLink?.toLowerCase()*/}
                    {/*                    );*/}
                    {/*                const isOpen = expandedMenus[menu.Id];*/}
                    {/*                return (*/}
                    {/*                    <li key={menu.Id}>*/}
                    {/*                        <div*/}
                    {/*                            className={`menu-item${parentActive ? ' active' : ''}`}*/}
                    {/*                            onClick={() => toggleExpand(menu.Id)}*/}
                    {/*                        >*/}
                    {/*                            <Link*/}
                    {/*                                to={menu.MenuLink}*/}
                    {/*                                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}*/}
                    {/*                                onClick={e => menu.children?.length > 0 && e.preventDefault()}*/}
                    {/*                            >*/}
                    {/*                                <span style={{ fontSize: '15px', lineHeight: 1, flexShrink: 0 }}>*/}
                    {/*                                    {getIcon(menu.MenuName)}*/}
                    {/*                                </span>*/}
                    {/*                                {menu.MenuName}*/}
                    {/*                            </Link>*/}
                    {/*                            {menu.children?.length > 0 && (*/}
                    {/*                                <span*/}
                    {/*                                    className="arrow"*/}
                    {/*                                    style={{*/}
                    {/*                                        transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',*/}
                    {/*                                        transition: 'transform 0.2s ease',*/}
                    {/*                                        display: 'inline-block',*/}
                    {/*                                    }}*/}
                    {/*                                >*/}
                    {/*                                    ›*/}
                    {/*                                </span>*/}
                    {/*                            )}*/}
                    {/*                        </div>*/}
                    {/*                        {menu.children?.length > 0 && isOpen && (*/}
                    {/*                            <ul className="submenu">*/}
                    {/*                                {menu.children.map(sub => (*/}
                    {/*                                    <li key={sub.Id}>*/}
                    {/*                                        <Link*/}
                    {/*                                            to={sub.MenuLink}*/}
                    {/*                                            className={*/}
                    {/*                                                location.pathname.toLowerCase() === sub.MenuLink?.toLowerCase()*/}
                    {/*                                                    ? 'active' : ''*/}
                    {/*                                            }*/}
                    {/*                                        >*/}
                    {/*                                            {sub.MenuName}*/}
                    {/*                                        </Link>*/}
                    {/*                                    </li>*/}
                    {/*                                ))}*/}
                    {/*                            </ul>*/}
                    {/*                        )}*/}
                    {/*                    </li>*/}
                    {/*                );*/}
                    {/*            })*/}
                    {/*        )}*/}
                    {/*    </ul>*/}
                    {/*</div>*/}
                    {/* Invoice Content */}
                    <div className="invoice-content">
                        <div className="invoice-header">
                            <h2 className="invoice-title">{pageTitle}</h2>
                        </div>
                        <Container className="invoice-container">
                            <div className="details-grid invoice-grid">

                                {/* Invoice Type */}
                                <div className="form-group">
                                    <label htmlFor="invoiceType">Invoice Type <span className="required-field">*</span></label>
                                    <select id="invoiceType" name="invoiceType" value={formData.invoiceType}
                                        onChange={handleChange} disabled={disabled} className="form-input">
                                        <option value="">Select</option>
                                        <option value="Tax Invoice">Tax Invoice</option>
                                        <option value="Debit Note">Debit Note</option>
                                        <option value="Credit Note">Credit Note</option>
                                        <option value="Proforma Invoice">Proforma Invoice</option>
                                    </select>
                                    {errors.invoiceType && <span className="error-text">{errors.invoiceType}</span>}
                                </div>

                                {/* Supplier Type + PO Type */}
                                <div className="form-group">
                                    <label htmlFor="supplierType">Supplier Type <span className="required-field">*</span></label>
                                    <div style={{ display: "flex", gap: "8px" }}>
                                        <select id="supplierType" name="supplierType" value={formData.supplierType}
                                            onChange={handleChange} disabled={disabled} className="form-input" style={{ flex: 1 }}>
                                            <option value="">Select</option>
                                            <option value="1">Supply of Material</option>
                                            <option value="2">Supply of Service</option>
                                            <option value="3">Both</option>
                                        </select>                                     
                                    </div>
                                    {errors.supplierType && <span className="error-text">{errors.supplierType}</span>}
                                </div>

                                <div className="form-group">
                                    <label htmlFor="poType">PO / Agreement <span className="required-field">*</span></label>
                                    <div style={{ display: "flex", gap: "8px" }}>
                                        <select id="poType" name="poType" value={formData.poType}
                                            onChange={handleChange}
                                            disabled={disabled || formData.supplierType === "1"}
                                            className="form-input" style={{ flex: 1 }}>
                                            <option value="">Select</option>
                                            <option value="PO">PO</option>
                                            <option value="Agreement">Agreement</option>
                                            <option value="Approval">Approval</option>
                                        </select>
                                    </div>
                                    {errors.poType && <span className="error-text">{errors.poType}</span>}
                                </div>

                                {/* PO Number — hidden entirely when Agreement is selected */}
                                {formData.poType === "PO" && (
                                    <div className="form-group">
                                        <label htmlFor="poNo">
                                            PO Number
                                            <span className="required-field">*</span>
                                        </label>
                                        <input type="text" id="poNo" name="poNo" value={formData.poNo}
                                            onChange={handleChange} disabled={disabled}
                                            placeholder="Enter PO No."
                                            className="form-input" />
                                        {errors.poNo && <span className="error-text">{errors.poNo}</span>}

                                    </div>
                                )}

                                {/* PO Date + PO Copy — only when NOT Agreement */}
                                {formData.poType === "PO" && (
                                    <>
                                        <div className="form-group">
                                            <label htmlFor="poDate">PO Date <span className="required-field">*</span></label>
                                            <input type="date" id="poDate" name="poDate" value={formData.poDate}
                                                onChange={handleChange} disabled={disabled} className="form-input" />
                                            {errors.poDate && <span className="error-text">{errors.poDate}</span>}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="poCopy">PO Copy <span className="required-field">*</span></label>
                                            <input type="file" id="poCopy" ref={poFileRef} name="poCopy"
                                                onChange={(e) => handleFileChange(e, "poCopy")} disabled={disabled} className="form-input" />
                                            {formData.fileNameAgreement ? (
                                                <button type="button" className="file-name-display"
                                                    style={{ border: "none", background: "none", cursor: "pointer", padding: 0, textAlign: "left" }}
                                                    onClick={() => viewUploadedFile(formData.poFilePath, formData.fileNameAgreement)}>
                                                    <span className="file-icon">&#128206;</span>{formData.fileNameAgreement}
                                                </button>
                                            ) : (disabled && <span className="file-name-none">No file uploaded</span>)}
                                            {errors.poCopy && <span className="error-text">{errors.poCopy}</span>}
                                        </div>
                                    </>
                                )}

                                {/* Agreement fields — only when Agreement selected */}
                                {formData.poType === "Agreement" && (
                                    <>
                                        {/* Agreement Reference */}
                                        <div className="form-group">
                                            <label htmlFor="agreementRef">Agreement Reference</label>
                                            <select id="agreementRef" name="agreementRef" value={formData.agreementRef}
                                                onChange={handleChange} disabled={disabled} className="form-input">
                                                <option value="">Select</option>
                                                {agreementList.map(a => (
                                                    <option key={a.agreementId} value={a.agreementId}>
                                                        {a.agreementDate}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.agreementRef && <span className="error-text">{errors.agreementRef}</span>}
                                        </div>

                                        

                                        {/* View Agreement File from DB */}
                                        {(() => {
                                            const selected = agreementList.find(
                                                a => String(a.agreementId) === String(formData.agreementRef)
                                            );

                                            if (!selected || formData.agreementType === "Opened Agreement") return null;

                                            return (
                                                <div className="form-group">
                                                    <label>View Agreement File</label>
                                                    <button
                                                        type="button"
                                                        onClick={() => viewAgreementFile(selected)}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: "8px",
                                                            color: "white",
                                                            fontWeight: "600",
                                                            border: "none",
                                                            borderRadius: "8px",
                                                            padding: "10px 24px",
                                                            background: "#2563eb",
                                                            cursor: "pointer",
                                                            fontSize: "14px"
                                                        }}
                                                    >
                                                        {selected.fileName
                                                            ? `${/\.(pdf|jpe?g|png|gif)$/i.test(selected.fileName) ? "View" : "Download"} ${selected.fileName}`
                                                            : "View File"}
                                                    </button>

                                                </div>
                                            );
                                        })()}


                                    </>
                                )}

                                {/* Invoice Copy */}
                                <div className="form-group">
                                    <label htmlFor="invoiceCopy">Invoice Copy <span className="required-field">*</span></label>
                                    <input type="file" id="invoiceCopy" ref={invoiceFileRef} name="invoiceCopy"
                                        onChange={(e) => handleFileChange(e, "invoiceCopy")} disabled={disabled} className="form-input" />
                                    {formData.fileName ? (
                                        <button type="button" className="file-name-display"
                                            style={{ border: "none", background: "none", cursor: "pointer", padding: 0, textAlign: "left" }}
                                            onClick={() => viewUploadedFile(formData.invoiceFilePath, formData.fileName)}>
                                            <span className="file-icon">&#128206;</span>{formData.fileName}
                                        </button>
                                    ) : (disabled && <span className="file-name-none">No file uploaded</span>)}
                                    {errors.invoiceCopy && <span className="error-text">{errors.invoiceCopy}</span>}
                                </div>

                                {/* Invoice Date */}
                                <div className="form-group">
                                    <label htmlFor="invoiceDate">Invoice Date <span className="required-field">*</span></label>
                                    <input type="date" id="invoiceDate" name="invoiceDate" value={formData.invoiceDate}
                                        onChange={handleChange} disabled={disabled} className="form-input" />
                                    {errors.invoiceDate && <span className="error-text">{errors.invoiceDate}</span>}
                                </div>

                                {/* Invoice Number */}
                                <div className="form-group">
                                    <label htmlFor="invoiceNo">Invoice Number <span className="required-field">*</span></label>
                                    <input type="text" id="invoiceNo" name="invoiceNo" value={formData.invoiceNo}
                                        onChange={handleChange} disabled={disabled} placeholder="Enter Invoice No." className="form-input" />
                                    {errors.invoiceNo && <span className="error-text">{errors.invoiceNo}</span>}
                                </div>
                                        

                            {/* Timesheet (optional) */}
                            <div className="form-group">
                                <label htmlFor="timesheet">Upload Timesheet (If Applicable)</label>
                                <input type="file" id="timesheet" ref={timesheetRef} name="timesheet"
                                    onChange={(e) => handleFileChange(e, "timesheet")} disabled={disabled} className="form-input" />
                                    {formData.fileNameTimeSheet ? (
                                        <button type="button" className="file-name-display"
                                            style={{ border: "none", background: "none", cursor: "pointer", padding: 0, textAlign: "left" }}
                                            onClick={() => viewUploadedFile(formData.timesheetFilePath, formData.fileNameTimeSheet)}>
                                            <span className="file-icon">&#128206;</span>{formData.fileNameTimeSheet}
                                        </button>
                                    ) : (disabled && <span className="file-name-none">No file uploaded</span>)}
                            </div>

                            {/* Delivery Challan (material / both only) */}
                                {(formData.supplierType === "1" || formData.supplierType === "3") && formData.poType !== "Agreement" && (
                                    <div className="form-group">
                                        <label htmlFor="deliveryChallanNo">Delivery Challan Number <span className="required-field">*</span></label>
                                        <input type="text" id="deliveryChallanNo" name="deliveryChallanNo"
                                            value={formData.deliveryChallanNo} onChange={handleChange} disabled={disabled}
                                            placeholder="Enter Challan No." className="form-input" />
                                        {errors.deliveryChallanNo && <span className="error-text">{errors.deliveryChallanNo}</span>}
                                    </div>
                                )}

                              

                    </div> {/* ← END details-grid */}

                            
                            {/* Invoice Items Table */}
                            <div className="invoice-items-wrap">
                                <table className="invoice-items-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "4%" }}>Sr. No</th>
                                            <th style={{ width: "17%" }}>Description</th>
                                            {formData.supplierType !== "2" && <th style={{ width: "8%" }}>Ordered Qty.</th>}
                                            {formData.supplierType !== "2" && <th style={{ width: "8%" }}>Supplied Qty.</th>}
                                            <th style={{ width: "10%" }}>Invoice Value</th>
                                            <th style={{ width: "6%" }}>CGST (%)</th>
                                            <th style={{ width: "6%" }}>SGST (%)</th>
                                            <th style={{ width: "6%" }}>IGST (%)</th>
                                            <th style={{ width: "10%" }}>Total Value</th>
                                            <th style={{ width: "12%" }}>Remarks</th>
                                            {showActionsCol && <th style={{ width: "13%" }}>Actions</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={index} className="invoice-row">
                                                <td className="sr-cell">{row.SlNo}</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="Description"
                                                        value={row.Description}
                                                        onChange={(e) => handleRowChange(e, index)}
                                                        disabled={disabled}
                                                        className="input-control desc-input"
                                                    />
                                                    {rowErrors[index]?.Description && <div className="text-danger small">{rowErrors[index].Description}</div>}
                                                </td>
                                                {formData.supplierType !== "2" && (
                                                    <>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                name="Qty"
                                                                value={row.Qty || ""}
                                                                onChange={(e) => handleRowChange(e, index)}
                                                                onKeyPress={handleIntegerInput}
                                                                disabled={disabled}
                                                                className="input-control pct-input"
                                                                placeholder="Qty"
                                                                style={{ textAlign: "right" }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                name="RcvQty"
                                                                value={row.RcvQty || ""}
                                                                onChange={(e) => handleRowChange(e, index)}
                                                                onKeyPress={handleIntegerInput}
                                                                disabled={disabled}
                                                                className="input-control pct-input"
                                                                placeholder="Qty"
                                                                style={{ textAlign: "right" }}
                                                            />
                                                        </td>
                                                    </>
                                                )}
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="invoiceValue"
                                                        value={row.invoiceValue || ""}
                                                        onChange={(e) => handleRowChange(e, index)}
                                                        onKeyPress={handleDecimalInput}
                                                        disabled={disabled}
                                                        className="input-control text-end"
                                                        placeholder="0.00"
                                                        style={{ textAlign: "right" }}
                                                    />
                                                    {rowErrors[index]?.invoiceValue && <div className="text-danger small">{rowErrors[index].invoiceValue}</div>}
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="cgst"
                                                        value={row.cgst || ""}
                                                        onChange={(e) => handleRowChange(e, index)}
                                                        onKeyPress={handleDecimalInput}
                                                        disabled={disabled}
                                                        className="input-control pct-input text-end"
                                                        placeholder="%"
                                                        maxLength="5"
                                                        style={{ textAlign: "right" }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="sgst"
                                                        value={row.sgst || ""}
                                                        onChange={(e) => handleRowChange(e, index)}
                                                        onKeyPress={handleDecimalInput}
                                                        disabled={disabled}
                                                        className="input-control pct-input text-end"
                                                        placeholder="%"
                                                        maxLength="5"
                                                        style={{ textAlign: "right" }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="igst"
                                                        value={row.igst || ""}
                                                        onChange={(e) => handleRowChange(e, index)}
                                                        onKeyPress={handleDecimalInput}
                                                        disabled={disabled}
                                                        className="input-control pct-input text-end"
                                                        placeholder="%"
                                                        maxLength="5"
                                                        style={{ textAlign: "right" }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="totalValue"
                                                        value={row.totalValue || ""}
                                                        readOnly
                                                        className="input-control text-end"
                                                        placeholder="0.00"
                                                        style={{ textAlign: "right", fontWeight: "700" }}
                                                    />
                                                    {rowErrors[index]?.totalValue && <div className="text-danger small">{rowErrors[index].totalValue}</div>}
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="remark"
                                                        value={row.remark || ""}
                                                        onChange={(e) => handleRowChange(e, index)}
                                                        disabled={disabled}
                                                        className="input-control remark-input"
                                                        placeholder="Remarks"
                                                    />
                                                    {rowErrors[index]?.remark && <div className="text-danger small">{rowErrors[index].remark}</div>}
                                                </td>
                                                {showActionsCol && (
                                                    <td className="actions-cell">
                                                        <button type="button" className="row-add" onClick={addRow}>+ Add</button>
                                                        {rows.length > 1 && (
                                                            <button type="button" className="row-del" onClick={() => removeRow(index)}>Delete</button>
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {/* Action Buttons */}
                            <div className="invoice-actions">
                                {isCreateMode && (
                                    <button className="submit-btn" onClick={handleSubmit} disabled={isSubmitting}>
                                        {isSubmitting ? "Submitting..." : "Submit Invoice"}
                                    </button>
                                )}
                                {isViewMode && (
                                    <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
                                )}
                                {isModifyMode && (
                                    <>
                                        <button className="back-btn" onClick={() => navigate(-1)} disabled={isUpdating}>
                                            ← Back
                                        </button>
                                        <button className="submit-btn" onClick={handleUpdate} disabled={isUpdating}>
                                            {isUpdating ? "Updating..." : "Update"}
                                        </button>
                                    </>
                                )}
                            </div>
                            {error && <div className="message error" style={{ color: "red", marginTop: "10px" }}>{error}</div>}
                            {successMessage && <div className="message success">{successMessage}</div>}
                        </Container>
                    </div>
                </div>
            </div>
            
            {/* File Preview Modal */}
            {fileModalUrl && (
                <div style={{
                    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                    background: "rgba(0,0,0,0.6)", zIndex: 9999,
                    display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                    <div style={{
                        background: "white", borderRadius: "8px", width: "85%", height: "85%",
                        display: "flex", flexDirection: "column", overflow: "hidden"
                    }}>
                        <div style={{
                            display: "flex", justifyContent: "space-between", alignItems: "center",
                            padding: "14px 20px", background: "#2563eb"
                        }}>
                            <span style={{ fontWeight: "700", color: "white", fontSize: "16px" }}>
                                Agreement File Preview
                            </span>
                            <button
                                onClick={() => {
                                    if (fileModalUrl) URL.revokeObjectURL(fileModalUrl);
                                    setFileModalUrl(null);
                                    setFileModalType(null);
                                }}
                                style={{
                                    background: "transparent", color: "white", border: "none",
                                    fontSize: "20px", cursor: "pointer", lineHeight: 1
                                }}
                            >
                                ✕
                            </button>
                        </div>
                        <object data={fileModalUrl} type={fileModalType} style={{ flex: 1, width: "100%" }}>
                            <iframe
                                src={fileModalUrl}
                                style={{ flex: 1, border: "none", width: "100%" }}
                                title="Agreement File"
                            />
                        </object>
                    </div>
                </div>
            )}
        </DashboardLayout>
    );
};
export default CreateInvoice;